import styled from 'styled-components';
import ImagePc from '../../../assets/images/pc.png';

const VideoStyles = styled.div`
	position: relative;
	padding-top: 25px;
	padding-bottom: 62%;
	height: 0;

	video {
		box-sizing: border-box;
		background: url(${ImagePc}) center center no-repeat;
		background-size: contain;
		padding: 5.9% 11.5% 9.8%;
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}
`;

export default VideoStyles;
